import { createContext } from 'react';

import { type UseSavedFilterManager } from '@webapp/hooks/useSavedFilterManager'
import {
  type SavedFilterCollection,
  type SavedFilterCollectionSchemas,
} from '@webapp/hooks/useSavedFilterManager/types'

interface SaveFilterManagerContextType<
  CollectionId extends SavedFilterCollection,
  Filters extends { [key: string]: any },
  CollectionSchema extends SavedFilterCollectionSchemas[CollectionId],
> extends UseSavedFilterManager<CollectionId, Filters, CollectionSchema> {}

export const SaveFilterManagerContext =
  createContext<SaveFilterManagerContextType<any, any, any>>(null)
